import { ToolBase } from ".";

const fabric = require("../fabric").fabric;

export class ShapeTool extends ToolBase {

  /**
   * @inheritdoc
   */
  registerEvents() {
    let that = this;
    let canvas = this.imageEditor.canvas;
    let isDown, origX, origY, shape;

    canvas.on('mouse:down', function(o){
      if(!that.isActive) return;

      isDown = true;
      var pointer = canvas.getPointer(o.e);
      origX = pointer.x;
      origY = pointer.y;
      pointer = canvas.getPointer(o.e);

      shape = that.buildShape(pointer, origX, origY);

      canvas.add(shape);
    });

    canvas.on('mouse:move', function(o){
      if(!that.isActive || !isDown) return;
      var pointer = canvas.getPointer(o.e);
      that.mouseDrag(shape, pointer, origX, origY);
      canvas.renderAll();
    });

    canvas.on('mouse:up', function(o){
      if(!that.isActive) return;
      that.shapePlaced(shape);
      isDown = false;
    });
  }

  buildShape(pointer, origX, origY) {}

  mouseDrag(shape, pointer, origX, origY) {}

  shapePlaced(shape) {}

  setActive(value){
    this.isActive = value;
    if(value){
      this.imageEditor.canvas.discardActiveObject();
    }
  }

  getNewMesurementText(x,y) {
    let styleModule = this.imageEditor.getModule("style");

    return new fabric.IText("-", {
      fill: styleModule.fillColor,
      stroke: "white",
      strokeWidth: 0,
      color: styleModule.fillColor,
      cursorColor: styleModule.fillColor,
      transparentCorners: false,
      fontSize: styleModule.strokeSize,
      fontFamily: "Arial",
      editable: true,
      fontWeight: 800,
      left: x,
      top: y,
      selectable: false
    });
  }

}